import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';
import { createEntity, getEntity, reset, updateEntity } from './method-of-travel-to-work.reducer';

export const MethodOfTravelToWorkUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const methodOfTravelToWorkEntity = useAppSelector(state => state.methodOfTravelToWork.entity);
  const loading = useAppSelector(state => state.methodOfTravelToWork.loading);
  const updating = useAppSelector(state => state.methodOfTravelToWork.updating);
  const updateSuccess = useAppSelector(state => state.methodOfTravelToWork.updateSuccess);
  const geographicLevelValues = Object.keys(GeographicLevel);

  const handleClose = () => {
    navigate(`/method-of-travel-to-work${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.totalAllUsualResidents !== undefined && typeof values.totalAllUsualResidents !== 'number') {
      values.totalAllUsualResidents = Number(values.totalAllUsualResidents);
    }
    if (values.workMainlyAtHome !== undefined && typeof values.workMainlyAtHome !== 'number') {
      values.workMainlyAtHome = Number(values.workMainlyAtHome);
    }
    if (values.underground !== undefined && typeof values.underground !== 'number') {
      values.underground = Number(values.underground);
    }
    if (values.train !== undefined && typeof values.train !== 'number') {
      values.train = Number(values.train);
    }
    if (values.bus !== undefined && typeof values.bus !== 'number') {
      values.bus = Number(values.bus);
    }
    if (values.taxi !== undefined && typeof values.taxi !== 'number') {
      values.taxi = Number(values.taxi);
    }
    if (values.motorcycle !== undefined && typeof values.motorcycle !== 'number') {
      values.motorcycle = Number(values.motorcycle);
    }
    if (values.drivingCarVan !== undefined && typeof values.drivingCarVan !== 'number') {
      values.drivingCarVan = Number(values.drivingCarVan);
    }
    if (values.passengerCarVan !== undefined && typeof values.passengerCarVan !== 'number') {
      values.passengerCarVan = Number(values.passengerCarVan);
    }
    if (values.bicycle !== undefined && typeof values.bicycle !== 'number') {
      values.bicycle = Number(values.bicycle);
    }
    if (values.onFoot !== undefined && typeof values.onFoot !== 'number') {
      values.onFoot = Number(values.onFoot);
    }
    if (values.otherMethod !== undefined && typeof values.otherMethod !== 'number') {
      values.otherMethod = Number(values.otherMethod);
    }

    const entity = {
      ...methodOfTravelToWorkEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          geographicLevel: 'EXTRA_WARD',
          ...methodOfTravelToWorkEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="apiLocationApp.methodOfTravelToWork.home.createOrEditLabel" data-cy="MethodOfTravelToWorkCreateUpdateHeading">
            <Translate contentKey="apiLocationApp.methodOfTravelToWork.home.createOrEditLabel">
              Create or edit a MethodOfTravelToWork
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="method-of-travel-to-work-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('apiLocationApp.methodOfTravelToWork.geographicLevel')}
                id="method-of-travel-to-work-geographicLevel"
                name="geographicLevel"
                data-cy="geographicLevel"
                type="select"
              >
                {geographicLevelValues.map(geographicLevel => (
                  <option value={geographicLevel} key={geographicLevel}>
                    {translate(`apiLocationApp.GeographicLevel.${geographicLevel}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('apiLocationApp.methodOfTravelToWork.date')}
                id="method-of-travel-to-work-date"
                name="date"
                data-cy="date"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.methodOfTravelToWork.geography')}
                id="method-of-travel-to-work-geography"
                name="geography"
                data-cy="geography"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.methodOfTravelToWork.geographyCode')}
                id="method-of-travel-to-work-geographyCode"
                name="geographyCode"
                data-cy="geographyCode"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.methodOfTravelToWork.totalAllUsualResidents')}
                id="method-of-travel-to-work-totalAllUsualResidents"
                name="totalAllUsualResidents"
                data-cy="totalAllUsualResidents"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.methodOfTravelToWork.workMainlyAtHome')}
                id="method-of-travel-to-work-workMainlyAtHome"
                name="workMainlyAtHome"
                data-cy="workMainlyAtHome"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.methodOfTravelToWork.underground')}
                id="method-of-travel-to-work-underground"
                name="underground"
                data-cy="underground"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.methodOfTravelToWork.train')}
                id="method-of-travel-to-work-train"
                name="train"
                data-cy="train"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.methodOfTravelToWork.bus')}
                id="method-of-travel-to-work-bus"
                name="bus"
                data-cy="bus"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.methodOfTravelToWork.taxi')}
                id="method-of-travel-to-work-taxi"
                name="taxi"
                data-cy="taxi"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.methodOfTravelToWork.motorcycle')}
                id="method-of-travel-to-work-motorcycle"
                name="motorcycle"
                data-cy="motorcycle"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.methodOfTravelToWork.drivingCarVan')}
                id="method-of-travel-to-work-drivingCarVan"
                name="drivingCarVan"
                data-cy="drivingCarVan"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.methodOfTravelToWork.passengerCarVan')}
                id="method-of-travel-to-work-passengerCarVan"
                name="passengerCarVan"
                data-cy="passengerCarVan"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.methodOfTravelToWork.bicycle')}
                id="method-of-travel-to-work-bicycle"
                name="bicycle"
                data-cy="bicycle"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.methodOfTravelToWork.onFoot')}
                id="method-of-travel-to-work-onFoot"
                name="onFoot"
                data-cy="onFoot"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.methodOfTravelToWork.otherMethod')}
                id="method-of-travel-to-work-otherMethod"
                name="otherMethod"
                data-cy="otherMethod"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/method-of-travel-to-work" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default MethodOfTravelToWorkUpdate;
